import { z } from 'zod';

import { schemaGeneralEventApiResponse } from './GeneralResponse';
import { schemaId } from '../../utils/schema.utils';

export const schemaNoteAdded = schemaGeneralEventApiResponse.merge(
    z.object({
        payload: z.object({
            author: z.object({
                firstName: z.string(),
                id: schemaId,
                lastName: z.string(),
            }),
            content: z.string().min(1),
            favored: z.boolean().default(false),
            id: schemaId,
        }),
        type: z.literal('KreditDE_LoanRequest_NoteAdded'),
    }),
);

export const schemaApplicantNoteAdded = schemaGeneralEventApiResponse.merge(
    z.object({
        payload: z.object({
            applicantId: schemaId,
            author: z.object({
                firstName: z.string(),
                id: schemaId,
                lastName: z.string(),
            }),
            content: z.string().min(1),
            favored: z.boolean().default(false),
            id: schemaId,
        }),
        type: z.literal('KreditDE_LoanRequest_ApplicantNoteAdded'),
    }),
);

export const schemaNoteContentChanged = schemaGeneralEventApiResponse.merge(
    z.object({
        payload: z.object({
            content: z.string().min(1),
            id: schemaId,
        }),
        type: z.literal('KreditDE_LoanRequest_NoteContentChanged'),
    }),
);

export const schemaNoteFavorabilityChanged = schemaGeneralEventApiResponse.merge(
    z.object({
        payload: z.object({
            favored: z.boolean(),
            id: schemaId,
        }),
        type: z.literal('KreditDE_LoanRequest_NoteFavorabilityChanged'),
    }),
);

export const schemaApplicantNoteFavorabilityChanged = schemaGeneralEventApiResponse.merge(
    z.object({
        payload: z.object({
            applicantId: schemaId,
            favored: z.boolean(),
            id: schemaId,
        }),
        type: z.literal('KreditDE_LoanRequest_ApplicantNoteFavorabilityChanged'),
    }),
);

export const schemaNoteEventApiResponse = z.discriminatedUnion('type', [
    schemaNoteAdded,
    schemaApplicantNoteAdded,
    schemaNoteContentChanged,
    schemaNoteFavorabilityChanged,
    schemaApplicantNoteFavorabilityChanged,
]);

export type NoteEventApiResponse = z.infer<typeof schemaNoteEventApiResponse>;
export type NoteAdded = z.infer<typeof schemaNoteAdded>;
export type ApplicantNoteAdded = z.infer<typeof schemaApplicantNoteAdded>;
export type NoteContentChanged = z.infer<typeof schemaNoteContentChanged>;
export type NoteFavorabilityChanged = z.infer<typeof schemaNoteFavorabilityChanged>;
export type ApplicantNoteFavorabilityChanged = z.infer<typeof schemaApplicantNoteFavorabilityChanged>;
